<template>
    <div class="chaton-replay_msg">
        <textarea 
          :id="`input-text-message-${chatInfo.chatId}`" 
          ref="messageInputRef" 
          type="text" 
          v-model.trim="messageInput" 
          name="replay" 
          :placeholder="TRANS.type_message"
          autocomplete="off"
          class="chaton-form-control chaton-form-replay"
        ></textarea>
        <template v-if="!isMobileDevice">
            <a v-if="isResponsiveChat" @click.prevent="sendMessage()" href="javascript:void(0)" class="chaton-sendmsg" ><i class="chatonicon chaton-send"></i></a>
        </template>
      </div>
</template>

<script>
import { mapState } from "vuex";
import jQuery from "jquery";
const CHATON_SETTINGS = window.chaton_scripts_vars.chatSetting;
export default {
    name:'SendTextMessage',
    data(){
        return {
            isMobileDevice  : CHATON_SETTINGS.isMobileDevice,
        }
    },
    computed:{
        messageInput : {
            get () {
                return this.$store.getters.getMessageInput
            },
            set (value) {
                this.$store.commit('updateMessageInput', { 'text' : value })
            }
        },
        CurrentDate: function(){
            var myDate = new Date();
            let monthsList = ['January ', 'February ', 'March ', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];
            let date = myDate.getDate();
            let month = monthsList[myDate.getMonth()];
            let year = myDate.getFullYear();
            return `${month} ${date}, ${year}`;
        },
        chatInfo(){
            return this.$store.getters.getChatInfo
        },
        ...mapState({
            userProfile     : state => state.userProfile,
            isResponsiveChat : state => state.isResponsiveChat,
            isBlockedByMe   : state => {
                return state.chatInfo.isBlocked
            }
        })
    },
    updated() {
        this.autoHeightInput();
    },
    methods:{
        autoHeightInput(){
            let inputtextId = `#input-text-message-${this.chatInfo.chatId}`;
            var elmnt = document.getElementById(`input-text-message-${this.chatInfo.chatId}`);
            if(elmnt){
                let paddingTop = jQuery(inputtextId).css('padding-top').split('px')[0];
                let paddingBottom = jQuery(inputtextId).css('padding-bottom').split('px')[0];
                let padding = Number(paddingTop) + Number(paddingBottom);
                jQuery(inputtextId).height(0).height( elmnt.scrollHeight - padding);
                if (jQuery(inputtextId).height() >= 60) {
                    jQuery('textarea.chaton-form-replay').css("overflow", "auto");
                }else {
                    jQuery('textarea.chaton-form-replay').css("overflow", "hidden");
                }
            }
        },
        sendMessage(){
            this.openWhatsappChat()
        },
        openWhatsappChat(){
            if(this.messageInput){
                window.open(`https://wa.me/${this.chatInfo.userContact}?text=${this.messageInput}`, '_blank');
            }
        },
    },
    mounted(){
        const ele = document.getElementById(`input-text-message-${this.chatInfo.chatId}`);
        let _this = this;
        ele.addEventListener('keydown', function (e) {
        let keyCode = e.which || e.keyCode;
            if (keyCode === 13 && !e.shiftKey) {
                e.preventDefault();
                _this.sendMessage();
            }
        });

        this.$root.$on('openWhatsapp', (data)=>{
            if(data.chatId == this.chatInfo.chatId){
                this.openWhatsappChat()
            }
        })
    }
}
</script>